export const USER = `/v2/profile`;
export const MINISTRY_USER = `/v2/ministry/profile`;

export const USER_BY_ID = (id) => `/v2/profile/${id}`;
export const MINISTR_USER_BY_ID = (id) => `/v2/ministry/profile/${id}`;

export const CHANGE_PASSWORD = "v2/profile/change-password";
export const MINISTR_CHANGE_PASSWORD = "v2/ministry/profile/change-password";
